var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAvaliar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.73645 12.5041L7.00766 14.2624C7.30072 14.5555 7.96011 14.702 8.3997 14.702H11.1838C12.0629 14.702 13.0154 14.0426 13.2352 13.1635L14.9935 7.81512C15.3599 6.78941 14.7005 5.91023 13.6015 5.91023H10.6709C10.2313 5.91023 9.86499 5.5439 9.93826 5.03105L10.3046 2.68657C10.4511 2.02719 10.0115 1.29454 9.35214 1.07474C8.76602 0.854949 8.03337 1.14801 7.74031 1.5876L4.73645 6.05676",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.5041V5.3241C1 4.29839 1.43959 3.93207 2.4653 3.93207H3.19795C4.22366 3.93207 4.66325 4.29839 4.66325 5.3241V12.5041C4.66325 13.5298 4.22366 13.8961 3.19795 13.8961H2.4653C1.43959 13.8961 1 13.5298 1 12.5041Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAvaliar);
export default __webpack_public_path__ + "static/media/icon_avaliar.0b4cdf5ac2cec92ba7038484061664bf.svg";
export { ForwardRef as ReactComponent };